/*
 * @desc reudx intial state
 * @author simbawu
 * @date 2018-11-08
 */

import cookie from 'js-cookie';

const getQueryString = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const getToken = () => {
  let token;
  if (process.env.NODE_ENV === 'development') {
    token =
      getQueryString('token') ||
      cookie.get('token');
  } else {
    token = getQueryString('token') || cookie.get('token');
  }
  if (token) {
    cookie.remove('token');
    cookie.set('token', token);
  }

  return token;
};

const control = {};
const exerciseCheck = {};
const niceAudio = {};
const rectify = {};
const ui = {};
const logoutReason = {};
const gene = {
  firstBind: true,
  status: {}
};
const achievementMes = {};
const token = getToken() || '';

export {
  control,
  exerciseCheck,
  niceAudio,
  rectify,
  ui,
  token,
  logoutReason,
  gene,
  achievementMes
};
